import { render, staticRenderFns } from "./CompanySelectDialog.vue?vue&type=template&id=5ed3a522&scoped=true"
import script from "./CompanySelectDialog.vue?vue&type=script&lang=js"
export * from "./CompanySelectDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanySelectDialog.vue?vue&type=style&index=0&id=5ed3a522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3a522",
  null
  
)

export default component.exports